<template>
  <section
    class="app-main"
    :style="[hiddenSidebarStyle]"
  >
    <div class="container is-fluid is-marginless app-content">
      <levelbar />
      <transition
        mode="out-in"
        enter-active-class="fadeIn"
        leave-active-class="fadeOut"
        appear
      >
        <router-view class="animated fill-height" />
      </transition>
    </div>
  </section>
</template>

<script>
import Levelbar from './Levelbar'
import { mapGetters } from 'vuex'

export default {
  components: {
    Levelbar
  },
  computed: {
    ...mapGetters({
      sidebar: 'sidebar'
    }),
    hiddenSidebarStyle () {
      return this.sidebar.hidden ? { 'margin-left': 0 } : null
    }
  }
}
</script>

<style lang="scss">
@import '~bulma/sass/utilities/_all';

.app-main {
  height: 99%;
  padding-top: 50px;
  margin-left: 180px;
  margin-bottom: 100px;
  transform: translate3d(0, 0, 0);

  .container {
    height: 100%;
  }

  @include mobile() {
    margin-left: 0;
  }

}

.app-content {
  padding: 20px;
}
</style>
